<mat-card>
    <mat-tab-group mat-stretch-tabs="false">
        <mat-tab label="Generated NOC ">
            <br>
            <div *ngIf="!list_flag">
            <div class="d-flex justify-content-between mb-3">
                <div class="filter d-flex">
                    <i class="fa fa-search search_icon" aria-hidden="true"></i>
                    <input class="input-filter" placeholder="Search by Name, Letter Number"
                        (keyup)="applyFilter($any($event.target).value)">
                </div>
                
                <button  class="btn_create" (click)="export()">
                    Export
                </button>
            </div>
            <div class="example-container mt-1" style="overflow-y: auto;text-size-adjust: 2;">
                <table mat-table [dataSource]="datasource" matSort #sortCol1="matSort">

                    <ng-container matColumnDef="si_no">
                        <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>S.NO.

                        </th>
                        <td mat-cell flex-stretch *matCellDef="let element" class="right">
                            <!-- {{this.mainService.accInfo['account_short_name']}} -->
                            {{element['new_index']}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="file_number">
                        <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header> File No

                        </th>
                        <td mat-cell flex-stretch *matCellDef="let element" class="right">
                            {{ element.doc_local_no}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="file_desc">
                        <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>File Description

                        </th>
                        <td mat-cell flex-stretch *matCellDef="let element" class="right">
                            {{element.doc_desc}}
                        </td>
                    </ng-container>
                    <!-- <ng-container matColumnDef="role">
                    <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Role

                    </th>
                    <td mat-cell flex-stretch *matCellDef="let element" class="right">
                        {{element.role_cd}}
                    </td>
                </ng-container> -->

                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Status

                        </th>
                        <td mat-cell flex-stretch *matCellDef="let element" class="right">
                            {{ element.status}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Action

                        </th>
                        <td mat-cell flex-stretch *matCellDef="let element" class="right">

                            <button class="btn btn-primary" (click)="view(element)">View
                                File</button>&nbsp;
                            <button class="btn btn-primary" (click)="add_to_approval(element)">Add to
                                Approval</button>&nbsp;
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;">
                    </tr>
                </table>

                <mat-paginator #paginator1 [pageSizeOptions]="[10, 20]" showFirstLastButtons></mat-paginator>
            </div>
        </div>
         <div *ngIf="list_flag" style="overflow-x: hidden;">
                  <div class="row">
                    <div class="col-12 text-right">
                        <button class="btn btn-outline-primary" (click)="open_list()">Back</button>
                    </div>
                  </div>
                  <br>
                  <mat-horizontal-stepper [linear]="isLinear" #stepper1>
                    <mat-step [stepControl]="first" label="File Creation" completed="false">
                        <div class="row">
                            <div class="col-12">
                                <div class="div_header mt-3">
                                    <h6 class="text_sty">File Details</h6>
                                    <hr>
                                    <div class="inner_div mt-1">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <p>Applicant Name :</p>
                                            </div>
                                            <div class="col-md-6 text-right">
                                                {{show_Data_obj['file_details']['party_name']}}</div>
                                        </div>
                                        <div class="row ">
                                            <div class="col-md-6">
                                                <p>Applicant Mobile Number :</p>
                                            </div>
                                            <div class="col-md-6 text-right">
                                                {{show_Data_obj['file_details']['party_mobile']}}</div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <p>LDA Letter Number :</p>
                                            </div>
                                            <div class="col-md-6 text-right">
                                                {{show_Data_obj['file_details']['lda_letter_number']}}</div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <p>Building Type :</p>
                                            </div>
                                            <div class="col-6 text-right">
                                                {{show_Data_obj['file_details']['building_type']}}</div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <p>File Number :</p>
                                            </div>
                                            <div class="col-md-6 text-right">
                                                {{show_Data_obj['file_details']['file_number']}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div class="row mt-2">
                            <div class="col-12 text-center">
                                <button mat-button mat-raised-button class="btn btn-success"
                                    (click)=open_list()>Back</button> &nbsp;&nbsp;
                                <!--Back-->
                                <button mat-button mat-raised-button class="btn btn-primary"
                                    matStepperNext>Next</button>
                            </div>
                        </div>
                    </mat-step>

                    <mat-step [stepControl]="second" label="Note Sheet">

                        <br>
                        <div class="row">
                            <div class="col-12 text-right addmore" (click)="addmorenotesheet()">
                                <span style=" color: rgb(184, 47, 47); 
                        font-weight: 600;">
                                    +
                                </span> Add More
                            </div>
                        </div>

                        <div class="div_header mt-4">
                            <div class="borderr" *ngFor="let item of show_Data_obj['file_notesheet']; let i = index">
                                <h6 class="text_sty">{{i+1}}.Notsheet</h6>
                                <!-- <div class="row" *ngFor="let item2 of item.supp_doc; let j = index">
                            <div class="col-12">
                                <h6 class="supp_doc" (click)="view_correspondence(item2.supp_doc_name)">{{j+1}}.{{item2.supp_doc_name}}</h6>
                            </div>
                         </div> -->
                                <hr>
                                <div class="inner_div mt-3">
                                    <div [class.hindi_text]="item['lang']=='Hindi'" [innerHTML]="item['description']">
                                    </div>

                                    <!-- <div class="page font-weight-bold">{{i+1}}</div> -->
                                    <!-- <div class="corresondence" style="cursor: pointer;" (click)="viewCorr(item.notesheet_id,item.notesheet_no)">View Correspondence</div> -->

                                </div>
                                <div style="color: red;font-size: bold;text-align: right;">
                                    <!-- ({{UserObj[item['user_id']]}}) -->
                                </div>

                                <br>
                            </div>
                            <br>
                            <div *ngIf="current_noc_data" class="inner_div mt-3">
                                <h6 class="text_sty"> Added Notsheet</h6>
                                <hr>

                                <!-- <div  *ngFor="let item of show_Data_obj; let i = index"
                                style="border: 2px solid black;"> -->
                                <div [class.hindi_text]="current_noc_data['lang']=='Hindi'"
                                    [innerHTML]="current_noc_data['description']"></div>
                                <!-- </div> -->
                            </div>
                        </div>
                        <br>
                        <!-- <div *ngIf="current_noc_data"  style="border: 2px dotted black;"> -->
                        <!-- <div *ngIf="current_noc_data"  class="borderr">

                                <div  *ngFor="let item of show_Data_obj; let i = index"
                                style="border: 2px solid black;">
                                <div [class.hindi_text]="current_noc_data['lang']=='Hindi'"
                                    [innerHTML]="current_noc_data['description']"></div>
                               
                            </div>
                            <br>
                        </div> -->

                        <div class="row">
                            <div class="col-12 text-center">
                                <button mat-button mat-raised-button class="btn btn-success"
                                    matStepperPrevious>Back</button> &nbsp;&nbsp;
                                <!--Back-->
                                <button mat-button mat-raised-button class="btn btn-primary"
                                    matStepperNext>Next</button>
                            </div>
                        </div>

                    </mat-step>

                    <mat-step [stepControl]="third" label="Documents">
                        <br>

                        <div class="row">

                            <div class="col-12 text-right addmore" (click)="uploadmoredoc()">
                                <span style=" color: rgb(184, 47, 47); 
                             font-weight: 600;">
                                    +
                                </span> Add More
                            </div>
                        </div>
                        <br>
                        <div class="div div_header">
                            <h6 class="text_sty">Supporting Document</h6>
                            <hr>
                            <div class="row " *ngFor="let item of show_Data_obj.file_supp_doc; let i = index">
                                <div class="col-12 text_styy"
                                    (click)="view_correspondence(item.supp_doc_name,item.file_id)">{{i+1}}
                                    . {{item.supp_doc_name}}</div>
                                <!-- <div class="col-5">{{item.notesheet_id}}</div>
                           <div class="col-6"></div> -->
                            </div>
                            <!-- <div class="row " *ngFor="let item of NocObj['supportive_doc']; let j = index">
                                <div class="col-12 text_styy" (click)="view_correspondence(item.supp_doc_name,item.file_id)">{{j+1}}
                                    . {{item.supp_doc_name}}</div>
                             
                            </div> -->
                        </div>





                        <br>
                        <div class="row">
                            <div class="col-12 text-center">
                                <!-- <button mat-button mat-raised-button class="btn btn-danger" (click)=open_list()>Cancel</button> &nbsp;&nbsp; -->
                                <button mat-button mat-raised-button class="btn btn-success"
                                    matStepperPrevious>Back</button> &nbsp;&nbsp;
                                <!--Back-->
                                <!-- <button mat-button mat-raised-button class="btn btn-primary"
                                    *ngIf="eng_Dept_flag==false && ctp_flag ==true"
                                    (click)="submtctpdata()">Submit</button>
                                 -->
                                <!--Next-->
                                <button mat-button mat-raised-button class="btn btn-primary" 
                                (click)="submitjedata()">Submit</button>

                            </div>
                        </div>

                    </mat-step>




                </mat-horizontal-stepper>
            

         </div>


        </mat-tab>
        <mat-tab label="Objected NOC "></mat-tab>
    </mat-tab-group>
</mat-card>

<div class="modal" id="notesheetmodal">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <h4 class="modal-title">Remark</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">

                <br>
                <div class="row">
                    <div class="col-4 text-right">
                        <h6> Add Remark <span style="color: red;">*</span> : </h6>
                    </div>
                    <div class="col-4"></div>
                    <div class="col-4"></div>

                </div>
                <!-- New Code for Notesheet -->
                <div class="notesheet" *ngIf="added_notesheet">

                    <app-editor></app-editor>


                </div>


                <!-- Modal footer -->
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" (click)="addctpnotesheet()">Submit</button>
                    <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
                </div>

            </div>
        </div>
    </div>
</div>

<div class="modal" id="uploadmoredocmodal">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <h4 class="modal-title">Upload Document </h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">

                <br>
                <div class="row">
                    <!-- <div class="col-2">

                        </div> -->
                    <div class="col-4 text-left">
                        <h6 id="h">
                            Upload File :
                        </h6>
                    </div>

                    <div class="col-6 text-left">
                        <input #uploadsupprotivedocument type="file" multiple="true" accept="application/pdf"
                            class="upload-box form-control" style="border-color: black"
                            (change)="addsupprotivedoc($event)">
                    </div>
                    <!-- <div class="col-1"></div> -->
                </div>
                <br>
                <!-- Modal footer -->
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" data-dismiss="modal">Submit</button>
                    <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
                </div>

            </div>
        </div>
    </div>
</div>

<div class="modal" id="myModal3">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <h4 class="modal-title">Approval</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">

                <div class="row"
                    *ngIf="ApprovalUserService.vendorflag==false && ApprovalUserService.approvalflag==false">
                    <div class="col-4 text-right">
                        <h6>Select Forwarded To :</h6>
                    </div>
                    <div class="col-4">
                        <ng-select [items]="ApprovalUserService.workuser" bindLabel="desc" bindValue="user_id_appr"
                            [multiple]="false" placeholder="Select User" [(ngModel)]="forwarded_user_id"
                            [selectableGroup]="true" [selectableGroupAsModel]="false" [closeOnSelect]="true"
                            name="work_order_id">
                        </ng-select>
                    </div>
                </div>
                <br>
                <div class="row">
                    <div class="col-4 text-right">
                        <h6>Remark :</h6>
                    </div>
                    <div class="col-4">
                        <textarea style="width: 100%; height: 80px;" id="re" name="re" [(ngModel)]="appr_remark"
                            placeholder="Enter Your Remark" class="form-control"></textarea>
                    </div>
                </div>
                <br>

                <div>
                    <table class="table table-bordered"
                        style="width: 90%; margin-left: 5%;overflow-x:scroll;scroll-margin-block: 1; ">
                        <thead>
                            <tr style="background-color:  white;">
                                <th style="width: 20%;">S No.</th>
                                <th style="width: 20%;">Decription</th>
                                <th style="width: 60%;">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let ln of undertakings;let i = index">
                                <td>{{i+1}}</td>
                                <td>{{ln['desc']}}</td>
                                <td style="width: 60%;">
                                    <input type="checkbox" [(ngModel)]="ln['check']" style="color: green;">

                                </td>
                            </tr>

                        </tbody>

                    </table>
                </div>
                <br>
                <div class="row" style="border: black;">
                    <div class="col-4 text-right">
                        <input type="checkbox" [(ngModel)]="message_flag" id="vehicle1" name="vehicle1" value="Bike">
                    </div>
                    <div class="col-4">
                        Notify Them
                    </div>
                </div>
                <br>
                <div class="row"
                    *ngIf="ApprovalUserService.vendorflag==false && ApprovalUserService.approvalflag==false">
                    <div class="col-12 text-center">
                        <button class="btn btn-primary" data-dismiss="modal" (click)="Approvedapproval()">Submit
                        </button>
                    </div>
                </div>
                <div class="row"
                    *ngIf="ApprovalUserService.vendorflag==false && ApprovalUserService.approvalflag==true">
                    <div class="col-12 text-center">
                        <button class="btn btn-primary" data-dismiss="modal" (click)="lastlevelappr()">Submit
                        </button>
                    </div>
                </div>
                <br>

                <div *ngIf="ApprovalUserService.vendorflag==true" class="row">
                    <div class="col-12 text-center">
                        <button class="btn btn-primary" data-dismiss="modal" (click)="Approvedapproval()">Forward To
                            Vendor</button>
                    </div>
                </div>
                <!-- Modal footer -->
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
                </div>

            </div>
        </div>
    </div>
</div>